import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import moment from 'moment';
import _, { sortBy } from 'lodash';
import momentTz from 'moment-timezone';
import Header from '../../components/Header';
import {
  onGoBack,
  getUser,
  // SERVER_TIMEZONE
} from '../../common/globals';
import withGoBack from '../../common/withGoBack';
import withCaseFilter from '../../common/withCaseFilter';
import withNotify from '../../common/withNotify';
import withOnline from '../../common/withOnline';
import withLoader from '../../common/withLoader';
import withTableName from '../../common/withTableName';
import withCalendarFilter from '../../common/withCalendarFilter';
import withUser from '../../common/withUser';
import withSavedScrollPosition from '../../common/withSavedScrollPosition';
import {
  addComplianceAppData,
  cancelCase,
  listSingleCase,
  searchCases,
  updateCase,
  getShipments,
  updatePushToACM
} from '../../utils/utils';
import CaseRow from '../../components/CaseRow';
import {
  bulkManageCaseAdd,
  getTableCaseByCaseId,
  deleteCaseByCaseId,
  getCaseScheduleIDFilter,
  updateCaseByPrimaryId,
  updateCaseByCaseId,
  updateTableWiseCaseByCaseId,
  getCases,
  insertComplianceApp,
  getVhnPpcValue,
  getHospitalByCustomerNo,
} from '../../utils/db';
import Bugsnag from '../../helpers/bugsnag';
import ExceedsSearchResult from '../../components/Models/ExceedsSearchResult';
import ZeroProductSubmitModal from '../../components/Models/ZeroProductSubmitModal';
import MrnOrPatientIdModal from '../../components/Models/MrnOrPatientIdModal';
import RequiredMrnOrPatientId from '../../components/Models/RequiredMrnOrPatientId';
import AlreadySubmittedCase from '../../components/Models/AlreadySubmittedCase';
import CancelCaseModal from '../../components/Models/CancelCaseModal';
import CaseChangesNoLonger from '../../components/Models/CasesChangesNoLonger';
import withTeam from '../../common/withTeam';
// import DgrRequiredOnSubmitCase from '../../components/Models/DgrRequiredOnSubmitCase';
import VhnPpcModal from '../../components/Models/VhnPpcModal';
import VrasPpcModal from '../../components/Models/VrasPpcModal';
import withVhnPpcOtherCharge from '../../common/withVhnPpcOtherCharge';
import ArrowCollapse from '../../assets/images/arrow-collapse-vertical.png';
import ArrowExpand from '../../assets/images/arrow-expand-vertical.png';
import ClockTimeIcon from '../../assets/images/clock-time-three-outline.png';
import HospitalBoxIcon from '../../assets/images/hospital-box-outline.png';
import AscIcon from '../../assets/images/asc.png';
import DescIcon from '../../assets/images/desc.png';
import CartOutlineIcon from '../../assets/images/cart-outline.png';
import TruckOutlineIcon from '../../assets/images/Truck-new.png';
import AcmPushCaseConfirmModal from '../../components/Models/AcmPushCaseConfirmModal';
import AcmPushCaseStatusModal from '../../components/Models/AcmPushCaseStatusModal';
import CustCaseIDModal from '../../components/Models/CustCaseIDModal';
import RequiredCustCaseID from '../../components/Models/RequiredCustCaseID';

class FilterCases extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hideAndShowCard: false,
      filterCases: {},
      localFilterCases: [],
      casesDetail: [],
      caseDetail: {},
      cancelId: 0,
      acmCases: {},
      filterData: [],
      isGroup: false,
      hospitalGroupCasesList: [],
      hospitalGroupCasesListData: [],
      shipments: [],
      orderByFlag: 'asc',
      orderByFlagCard: false,
      indexKey: 1,
      scrollPosition: 0,
      acmPushCaseStatusCount: 0,
      acmMessageStatusFlag: [],
      acmMessageStatusMessage: '',
      hospitalUseCustCaseIDStatus: false,
    };
    this.exceedsSearchResult = null;
    this.zeroProductSubmitModal = null;
    this.mrnOrPatientModal = null;
    this.requiredmrnOrPatientModal = null;
    this.alreadySubmittedCase = null;
    this.cancelCaseModal = null;
    this.caseChangesNoLonger = null;
    this.vhnPpcModal = null;
    this.vrasPpcModal = null;
    this.dgrRequiredOnSubmitCaseModal = null;
    this.acmPushCaseStatusModal = null;
    this.acmPushCaseConfirmModal = null;
    this.custCaseIDModal = null;
    this.requiredCustCaseIDModal = null;
  }

  componentDidMount() {
    try {
      this.exceedsSearchResult = new window.bootstrap.Modal(window.$('#exceedsSearchResult'));
      this.zeroProductSubmitModal = new window.bootstrap.Modal(window.$('#zeroProductSubmitModal'));
      this.mrnOrPatientModal = new window.bootstrap.Modal(window.$('#mrnOrPatientIdModal'));
      this.requiredmrnOrPatientModal = new window.bootstrap.Modal(window.$('#requiredMrnOrPatientId'));
      this.alreadySubmittedCase = new window.bootstrap.Modal(window.$('#alreadySubmittedCase'));
      this.cancelCaseModal = new window.bootstrap.Modal(window.$('#cancelCaseModal'));
      this.caseChangesNoLonger = new window.bootstrap.Modal(window.$('#CaseChangesNoLongerModal'));
      this.vhnPpcModal = new window.bootstrap.Modal(window.$('#vhnPpcModalModal'));
      this.vrasPpcModal = new window.bootstrap.Modal(window.$('#vrasPpcModal'));
      this.dgrRequiredOnSubmitCaseModal = new window.bootstrap.Modal(window.$('#dgrRequiredOnSubmitCaseModal'));
      this.acmPushCaseStatusModal = new window.bootstrap.Modal(window.$('#acmPushCaseStatusModal'));
      this.acmPushCaseConfirmModal = new window.bootstrap.Modal(window.$('#acmPushCaseConfirmModal'));
      this.custCaseModal = new window.bootstrap.Modal(window.$('#custCaseIDModal'));
      this.requiredCustCaseIDModal = new window.bootstrap.Modal(window.$('#requiredCustCaseID'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getFilterCases = async () => {
    try {
      const {
        notify, online, setLoader
      } = this.props;
      const { filterCases } = this.state;
      let casesData = [];
      const searchData = {};

      searchData.Date_start = filterCases.mix !== undefined
        ? filterCases.mix[0] !== undefined ? moment(filterCases.mix[0].split('-')[0], 'DD MMM YYYY').format('YYYY/MM/DD') : '' : '';
      searchData.Date_end = filterCases.mix !== undefined
        ? filterCases.mix[0] !== undefined ? moment(filterCases.mix[0].split('-')[1], 'DD MMM YYYY').format('YYYY/MM/DD') : '' : '';
      searchData.CoverRep = filterCases.selectedRefs !== undefined
        ? JSON.stringify(filterCases.selectedRefs)
        : [];
      searchData.Hospital = filterCases.selectHospitals !== undefined
        ? JSON.stringify(filterCases.selectHospitals)
        : [];
      searchData.SurgeonName = filterCases.selectSurgeon !== undefined
        ? JSON.stringify(filterCases.selectSurgeon)
        : [];
      searchData.AltCaseType = filterCases.selectedTypes !== undefined
        ? JSON.stringify(filterCases.selectedTypes)
        : [];
      searchData.ProcedureType = filterCases.ProcedureType !== undefined
        ? JSON.stringify(filterCases.ProcedureType)
        : [];
      searchData.Side = filterCases.Side !== undefined
        ? JSON.stringify(filterCases.Side)
        : [];
      searchData.PatientID = filterCases.PatientID !== undefined
        ? JSON.stringify(filterCases.PatientID.map((element) => element.trim().toUpperCase()))
        : [];
      searchData.RepNotes = filterCases.RepNotes !== undefined
        ? JSON.stringify(filterCases.RepNotes.map((element) => element.trim()))
        : [];
      searchData.Comments = filterCases.Comments !== undefined
        ? JSON.stringify(filterCases.Comments.map((element) => element.trim()))
        : [];
      searchData.SurgeonNotes = filterCases.SurgeonNotes !== undefined
        ? JSON.stringify(filterCases.SurgeonNotes.map((element) => element.trim()))
        : [];
      searchData.PONumber = filterCases.PONumber !== undefined
        ? filterCases.PONumber[0] : '';
      searchData.Keyword = filterCases.keywordSearch !== undefined
        ? JSON.stringify(filterCases.keywordSearch.map((element) => element.trim())) : [];
      searchData.VelysUsed = filterCases.Velys !== undefined
        ? filterCases.Velys[0] : '';
      searchData.CaseNo = filterCases.CaseNo !== undefined
        ? filterCases.CaseNo[0] : '';
      const arraySearchData = {};
      if (filterCases.ProductNo !== undefined) {
        arraySearchData.ProductNo = filterCases.ProductNo;
      }
      this.getFilterCases(filterCases);
      if (online) {
        setLoader(true);
        const data = {
          string: searchData,
          array: arraySearchData
        };
        searchData !== ''
          && searchCases(data).then(async (response) => {
            setLoader(false);
            const { status, message } = response;

            if (status) {
              casesData = response.hasOwnProperty('data') ? response.data : [];
              if (response.hasOwnProperty('data')) {
                this.setState({
                  filterData: response.data
                });

                // Set filter cases to local db
                if (casesData.length) {
                  const caseRes = await getCases();
                  const result = casesData.filter((o1) => !caseRes.some(
                    (o2) => o1.RepCaseNo === o2.RepCaseNo
                  ));
                  if (Object.keys(result).length > 0) {
                    await bulkManageCaseAdd(result);
                  }
                }

                // Get filter cases from local db
                this.getFilterCases(filterCases);
              } else {
                this.setState({ localFilterCases: [], casesDetail: [] });
                notify({ type: 'error', message });
              }
            } else {
              notify({ type: 'error', message });
            }
          });
      } else {
        notify({
          type: 'error',
          message: 'You must have as internet connection. Please check your connection and try again.',
          time: 3
        });
      }
      this.setState({ filterCases });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  getFilterCases = async (caseFilter) => {
    try {
      const { setLoader, savedScrollPosition } = this.props;
      const { filterData, shipments, orderByFlag } = this.state;
      for (const value in caseFilter) {
        if (caseFilter[value].length === 0 || caseFilter[value] === '' || caseFilter[value] === []) {
          delete caseFilter[value];
        }
      }
      const caseScheduleID = [];
      filterData.map((value) => {
        caseScheduleID.push(value.CaseScheduleID);
      });
      let localFilterCases = [];
      setLoader(true);
      localFilterCases = await getCaseScheduleIDFilter(caseScheduleID);

      // Use Sort By Date
      const casesListGroupsSort = _.chain(localFilterCases)
        .orderBy(['CaseDate'], [orderByFlag])
        .groupBy('CaseDate')
        .map((value, key) => {
          // Filter the Case Sets Qty
          const caseSets = value.filter((c) => c.case_sets.length > 0).map((set) => {
            let setsQty = 0;
            setsQty = set.case_sets.reduce((sum, { Quantity }) => sum + parseInt(Quantity, 10), 0);
            return ({ qty: setsQty });
          });

          const totalQty = _.sumBy(caseSets, 'qty');

          return (
            {
              date: key, data: value, qty: totalQty, dataNonGroup: value
            }
          );
        })
        .value();

      // Use Customer Name
      const casesListGroupsNew = casesListGroupsSort.map((item) => {
        if (item.dataNonGroup.length > 0) {
          item.dataNonGroup.sort((a, b) => a.CaseTime.localeCompare(b.CaseTime));
        }

        if (item.data.length > 0) {
          // item.data.sort((a, b) => a.CaseTime.localeCompare(b.CaseTime));

          const casesListGroups1 = _.chain(item.data)
            .orderBy(['CaseTime'], ['asc'])
            .groupBy('CustomerName')
            .map((value, key) => {
              // Filter the Case Sets Qty
              const caseSets = value.filter((c) => c.case_sets.length > 0).map((set) => {
                let setsQty = 0;
                setsQty = set.case_sets.reduce(
                  (
                    sum, { Quantity }
                  ) => sum + parseInt(Quantity, 10), 0
                );

                return ({ qty: setsQty });
              });

              const totalQty = _.sumBy(caseSets, 'qty');
              const caseId = value[0].id;

              return (
                {
                  customer: key, data: value, qty: totalQty, id: caseId
                }
              );
            })
            .value();

          const sortedCaseGroup = casesListGroups1.map((items) => {
            const ownShipments = shipments.filter(
              (shipment) => shipment.ShipToLoc === items.customer
            );
            if (!ownShipments.length) {
              return {
                ...items,
                hasShipments: !!ownShipments.length
              };
            }

            const shipFromLoc = ownShipments
              .some(
                (shipment) => shipment.ShipFromLoc === 'DEPUY'
              )
              && shipments.some(
                (shipment) => shipment.ShipFromLoc === 'OFFICE'
              )
              ? 'ALL' : ownShipments.some((shipment) => shipment.ShipFromLoc === 'DEPUY')
                ? 'DEPUY' : 'OFFICE';

            return {
              ...items,
              shipFromLoc,
              hasShipments: !!ownShipments.length
            };
          });

          item.data = sortedCaseGroup;
        }

        return {
          ...item
        };
      });

      /*  let localFilterCases = [];
      if (Object.keys(caseFilter).length > 0) {
        setLoader(true);
        localFilterCases = await filterCase(caseFilter, 'Cases');
      } */

      this.setState({
        localFilterCases,
        casesDetail: localFilterCases,
        hospitalGroupCasesListData: casesListGroupsNew
      });

      if (savedScrollPosition > 0) {
        window.scrollTo(0, savedScrollPosition, 'instant');
      }

      setTimeout(() => {
        setLoader(false);
      }, 500);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRedirect = (path) => {
    try {
      const { setSavedScrollPosition } = this.props;

      const currentScrollPosition = window.pageYOffset;
      setSavedScrollPosition(currentScrollPosition);

      this._onGoBack();
      browserHistory.push(path);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onUnselectValue = async (key, index) => {
    try {
      const { caseFilter, setCaseFilter } = this.props;
      const { filterCases } = this.state;

      if (filterCases[key].length > 1) {
        filterCases[key].splice(index, 1);
      } else {
        delete caseFilter[key];
        delete filterCases[key];
      }
      setCaseFilter(caseFilter);
      this.setState({ filterCases }, () => this._getFilterCases());
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onEditFilter = () => {
    try {
      const { goBack } = this.props;
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClearFilter = () => {
    try {
      const {
        setCaseFilter,
        setCalendarFilter,
        setSavedScrollPosition
      } = this.props;

      /* const filterCases = {};
      this.setState({ filterCases }, async () => {
        await this._getFilterCases();
      });
      onGoBack(goBack); */

      setCalendarFilter({});
      setCaseFilter({});
      setSavedScrollPosition(0);
      this._onGoBack();
      browserHistory.push('/manage-cases');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFilter = (data) => {
    try {
      const { filterCases } = this.state;
      const { notify, setCaseFilter } = this.props;
      for (const value in data) {
        if (data[value] === null || data[value] === undefined || data[value] === '' || data[value] === 'NONE') {
          notify({ type: 'warning', message: 'No data to filter', time: 3 });
        } else {
          const key = Object.keys(data)[0];
          if (!filterCases.hasOwnProperty(key)) {
            filterCases[key] = [];
          }
          if (!filterCases[key].includes(data[key])) {
            filterCases[key] = [...filterCases[key], data[key]];
          }
          setCaseFilter(filterCases);
          this.setState({
            filterCases
          }, () => {
            this._getFilterCases();
          });
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  longPressFilter = () => {
    try {
      const { casesDetail, filterCases } = this.state;
      let data = [...casesDetail];
      if (Object.keys(filterCases).length > 0) {
        if (filterCases.hasOwnProperty('selectSurgeon')) {
          data = (data.filter((item) => filterCases.selectSurgeon.includes(item.SurgeonName)));
        }
        if (filterCases.hasOwnProperty('selectHospitals')) {
          data = (data.filter((item) => filterCases.selectHospitals.includes(item.CustomerName)));
        }
        if (filterCases.hasOwnProperty('selectedRefs')) {
          data = (data.filter((item) => filterCases.selectedRefs.includes(item.CoverRep)));
        }
        if (filterCases.hasOwnProperty('ProcedureType')) {
          data = (data.filter((item) => item.ProcedureType === filterCases.ProcedureType));
        }
        if (filterCases.hasOwnProperty('selectedTypes')) {
          data = (data.filter((item) => filterCases.selectedTypes.includes(item.CaseType)));
        }
        if (filterCases.hasOwnProperty('Side')) {
          data = (data.filter((item) => filterCases.Side.includes(item.Side)));
        }
        if (filterCases.hasOwnProperty('PatientID')) {
          data = (data.filter((item) => item.PatientID === filterCases.PatientID));
        }
      }
      this._updateCaseList(data, false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _updateCaseList = (caseList, detailUpdate = true) => {
    try {
      const response = sortBy(caseList, ['CaseTime', 'CustomerName', 'SurgeonName', 'PatientID']);
      if (detailUpdate) {
        this.setState({
          localFilterCases: response,
          casesDetail: response,
        });
      } else {
        this.setState({
          localFilterCases: response
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCancel = async (id) => {
    try {
      this.setState({ cancelId: id });
      this.cancelCaseModal.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCancelCaseBack = () => {
    try {
      this.cancelCaseModal.hide();
      this.setState({ acmCases: {} });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGetACMCase = async (id) => {
    try {
      const { tableName } = this.props;
      const acmCase = await getTableCaseByCaseId(id, tableName);
      if (acmCase.ACMCaseID !== null) {
        return this.setState({ acmCases: acmCase });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCaseCancel = async () => {
    try {
      const {
        notify, setLoader, online, tableName
      } = this.props;
      const { cancelId } = this.state;
      const caseRes = await getTableCaseByCaseId(cancelId, tableName);
      if (caseRes && caseRes.DGR === '1') {
        setLoader(true);
        this.caseChangesNoLonger.show();
        setLoader(false);
        return;
      }

      if (online) {
        const cancelCaseRes = await cancelCase(caseRes.CaseScheduleID);
        const { message, status } = cancelCaseRes;
        if (status) {
          setLoader(true);
          if (message.length > 0) {
            // notify({ type: 'success', message });
          }
          await deleteCaseByCaseId(caseRes.id);
          await this._getFilterCases();
          // browserHistory.push('/manage-cases');
        } else {
          notify({ type: 'error', message, time: 3 });
        }
        setLoader(false);
      } else {
        await deleteCaseByCaseId(caseRes.id);
        await this._getFilterCases();
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCaseSubmitted = () => {
    try {
      this.alreadySubmittedCase.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onOpenMrnPatientIdModal = async (id) => {
    try {
      const {
        tableName
      } = this.props;

      const caseRes = await getTableCaseByCaseId(id, tableName);

      if (typeof caseRes.CustomerNo !== 'undefined' && caseRes.CustomerNo !== null) {
        const hosptalRes = await getHospitalByCustomerNo(caseRes.CustomerNo);

        if (
          hosptalRes.UseCustCaseID === '1'
          && caseRes.CustCaseID === null
          && (caseRes.ProductSubmitted === null || caseRes.ProductSubmitted !== '1')
        ) {
          this.setState({
            hospitalUseCustCaseIDStatus: true
          });
        }
      }

      this.setState({
        mrnOrPatientCaseId: id
      });

      this.mrnOrPatientModal.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onOpenCustomerCaseModal = async (id) => {
    try {
      const {
        tableName
      } = this.props;

      this.setState({
        mrnOrPatientCaseId: id
      });

      const caseRes = await getTableCaseByCaseId(id, tableName);

      if (typeof caseRes.CustomerNo !== 'undefined' && caseRes.CustomerNo !== null) {
        const hosptalRes = await getHospitalByCustomerNo(caseRes.CustomerNo);

        if (
          hosptalRes.UseCustCaseID === '1'
          && caseRes.CustCaseID === null
          && (caseRes.ProductSubmitted === null || caseRes.ProductSubmitted !== '1')
        ) {
          this.setState({
            hospitalUseCustCaseIDStatus: true
          });

          this._onCustomerCaseIDStatus();
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCustomerCaseIDStatus = () => {
    try {
      const custCaseIDStatus = new window.bootstrap.Modal(window.$('#custCaseIDModal'));
      custCaseIDStatus.show();
    } catch (error) {
      Bugsnag.notify(error);
    }
  }

  _onNextCustomerCaseIDStatus = () => {
    try {
      const custCaseIDStatus = new window.bootstrap.Modal(window.$('#requiredCustCaseID'));
      custCaseIDStatus.show();
    } catch (error) {
      Bugsnag.notify(error);
    }
  }

  _onSubmitCase = async (id) => {
    try {
      const {
        notify, online, setLoader, tableName, team: { dgrRequired }
      } = this.props;
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      this.setState({
        caseDetail
      });
      // const responseJson = {};
      if (online) {
        if ((caseDetail.case_products.length > 0 || caseDetail.case_dgrs.length === 0)
          && caseDetail.ProductSubmitted === '0' && dgrRequired === 6 && caseDetail.case_dgrs.length === 0) {
          // notify({ type: 'error',
          // message: 'A DGR must be uploaded for this case before it can be submitted.' });
          this.dgrRequiredOnSubmitCaseModal.show();
          return;
        }
        if (caseDetail.case_products.length >= 0 && caseDetail.ProductSubmitted === '0') {
          this.zeroProductSubmitModal.show();
        } else {
          let responseJson = {};
          caseDetail.Submitted = '1';
          caseDetail.ProductSubmitted = (((caseDetail.case_dgrs.length > 0 || caseDetail.case_products.length > 0) && (caseDetail.ProductSubmitted === '0')) ? '1'
            : ((caseDetail.case_dgrs.length > 0 || caseDetail.case_products.length === 0) && (caseDetail.ProductSubmitted === '1')) ? '1' : null);
          // caseDetail.ProductSubmitted = (((caseDetail.case_dgrs.length > 0
          // || caseDetail.case_products.length >= 0)
          // && (caseDetail.ProductSubmitted === '0')) ? '1' : null);
          const newArrayOfObj = caseDetail.case_sets.map(({
            CasePlanId: CasePlanID,
            ...rest
          }) => ({
            CasePlanID,
            ...rest
          }));
          caseDetail.selectedSets = newArrayOfObj;
          setLoader(true);
          await updateCase(caseDetail);
          responseJson = await listSingleCase(caseDetail.CaseScheduleID);
          const { message, status } = responseJson;
          if (status) {
            const caseDetails = responseJson.data[0];
            caseDetails.id = parseInt(caseDetail.id, 10);
            caseDetails.CaseDate = caseDetail.CaseDate;
            caseDetails.CaseTime = caseDetail.CaseTime;
            // Update the response when update API change
            updateTableWiseCaseByCaseId(caseDetails.RepCaseNo, caseDetails, tableName);
            await this._getFilterCases();
          } else {
            notify({ type: 'error', message });
          }
        }
      } else {
        caseDetail.Sync = 1;
        caseDetail.Submitted = '1';
        caseDetail.ProductSubmitted = '1';
        updateCaseByPrimaryId(caseDetail.id, caseDetail);
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmitProductCaseNo = () => {
    try {
      this.zeroProductSubmitModal.hide();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onNextAddPatientIdOrMrn = () => {
    try {
      this.requiredmrnOrPatientModal.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAddPatientIdOrMrn = () => {
    try {
      this.mrnOrPatientModal.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAddVhnPpc = async (id) => {
    try {
      const { tableName, setLoader } = this.props;
      const { mrnOrPatientCaseId } = this.state;
      let caseDetail = {};
      if (id === undefined) {
        caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      } else {
        caseDetail = await getTableCaseByCaseId(id, tableName);
        this.setState({ mrnOrPatientCaseId: id });
      }
      if (caseDetail.VelysUsed === null) {
        this.vhnPpcModal.show();
        setLoader(false);
      } else if (caseDetail.case_products.length > 0) {
        this._onGoBack();
        browserHistory.push(`/manage-case/${id}/products/list`);
        setLoader(false);
      } else {
        this._onGoBack();
        browserHistory.push(`/manage-case/${id}/products/add`);
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVhnPpcYes = async () => {
    try {
      const {
        tableName, setVhnPpcOtherCharge, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const { mrnOrPatientCaseId } = this.state;

      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      let vhnPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        vhnPpcValue = await getVhnPpcValue(caseDetail.CustomerName);
      }

      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vhnPpcValue.VHN_PPC === '1' ? 'VHN-PPC' : 'VHN-Other',
        UserResponse: 'YES',
        // ResponseDate: momentTz(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: momentTz(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? '0' : '1'
      };
      setLoader(true);
      setVhnPpcOtherCharge(true);
      if (online) {
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              const newArrayOfObj = caseDetail.case_sets.map(({
                CasePlanId: CasePlanID,
                ...rest
              }) => ({
                CasePlanID,
                ...rest
              }));
              caseDetail.selectSets = newArrayOfObj;
              caseDetail.Submitted = '0';
              caseDetail.Synced = '0';
              caseDetail.VelysUsed = 'YES';
              await updateCase(caseDetail);
              updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
              if (complainAppData.ComplianceType === 'VHN-PPC') {
                this._onGoBack();
                browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add/other-charge`);
              } else {
                browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add`);
              }
            }
          });
      } else {
        await insertComplianceApp(complainAppData);
        caseDetail.Submitted = '0';
        caseDetail.Synced = '0';
        caseDetail.VelysUsed = 'YES';
        caseDetail.Sync = 1;
        updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
        if (complainAppData.ComplianceType === 'VHN-PPC') {
          this._onGoBack();
          browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add/other-charge`);
        } else {
          browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add`);
        }
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVhnPpcNo = async () => {
    try {
      const {
        tableName, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const { mrnOrPatientCaseId } = this.state;

      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      let vhnPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        vhnPpcValue = await getVhnPpcValue(caseDetail.CustomerName);
      }

      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vhnPpcValue.VHN_PPC === '1' ? 'VHN-PPC' : 'VHN-Other',
        UserResponse: 'NO',
        // ResponseDate: momentTz(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: momentTz(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? '0' : '1'
      };
      setLoader(true);
      if (online) {
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              this._onGoBack();
              browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add`);
            }
          });
      } else {
        await insertComplianceApp(complainAppData);
        this._onGoBack();
        browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add`);
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAddVrasPpc = async (id) => {
    try {
      const { tableName, setLoader } = this.props;
      const { mrnOrPatientCaseId } = this.state;
      let caseDetail = {};
      if (id === undefined) {
        caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      } else {
        caseDetail = await getTableCaseByCaseId(id, tableName);
        this.setState({ mrnOrPatientCaseId: id });
      }
      if (caseDetail.VelysUsed === null) {
        this.vrasPpcModal.show();
        setLoader(false);
      } else if (caseDetail.case_products.length > 0) {
        browserHistory.push(`/manage-case/${id}/products/list`);
        setLoader(false);
      } else {
        browserHistory.push(`/manage-case/${id}/products/add`);
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVrasPpcYes = async () => {
    try {
      const {
        tableName, setVhnPpcOtherCharge, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const { mrnOrPatientCaseId } = this.state;

      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      let vrasPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        vrasPpcValue = await getVhnPpcValue(caseDetail.CustomerName);
      }

      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vrasPpcValue.VRAS_PPC === '1' ? 'VRAS-PPC' : 'VRAS-Other',
        UserResponse: 'YES',
        // ResponseDate: momentTz(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: momentTz(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? '0' : '1'
      };
      setLoader(true);
      setVhnPpcOtherCharge(true);
      if (online) {
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              const newArrayOfObj = caseDetail.case_sets.map(({
                CasePlanId: CasePlanID,
                ...rest
              }) => ({
                CasePlanID,
                ...rest
              }));
              caseDetail.selectSets = newArrayOfObj;
              caseDetail.Submitted = '0';
              caseDetail.Synced = '0';
              caseDetail.VelysUsed = 'YES';
              await updateCase(caseDetail);
              updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
              if (complainAppData.ComplianceType === 'VRAS-PPC') {
                this._onGoBack();
                browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add/other-charge`);
              } else {
                browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add`);
              }
            }
          });
      } else {
        await insertComplianceApp(complainAppData);
        caseDetail.Submitted = '0';
        caseDetail.Synced = '0';
        caseDetail.VelysUsed = 'YES';
        caseDetail.Sync = 1;
        updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
        if (complainAppData.ComplianceType === 'VRAS-PPC') {
          this._onGoBack();
          browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add/other-charge`);
        } else {
          browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add`);
        }
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVrasPpcNo = async () => {
    try {
      const {
        tableName, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const { mrnOrPatientCaseId } = this.state;

      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      let vrasPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        vrasPpcValue = await getVhnPpcValue(caseDetail.CustomerName);
      }

      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vrasPpcValue.VRAS_PPC === '1' ? 'VRAS-PPC' : 'VRAS-Other',
        UserResponse: 'NO',
        // ResponseDate: momentTz(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: momentTz(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? '0' : '1'
      };
      setLoader(true);
      if (online) {
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              this._onGoBack();
              browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add`);
            }
          });
      } else {
        await insertComplianceApp(complainAppData);
        this._onGoBack();
        browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add`);
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onMrnPatientIdAdd = async (formData) => {
    try {
      const {
        notify, online, setLoader, tableName, user: { name }
      } = this.props;
      const { mrnOrPatientCaseId, hospitalUseCustCaseIDStatus } = this.state;
      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      let vhnPpcValue = {};

      if (caseDetail.CustomerName !== null) {
        vhnPpcValue = await getVhnPpcValue(caseDetail.CustomerName);
      }

      if (!Object.keys(formData).length > 0) {
        this._onNextAddPatientIdOrMrn();
        return;
      }

      if (formData.hasOwnProperty('patientId')) {
        caseDetail.PatientID = (formData.patientId !== null || formData.patientId !== undefined)
          ? formData.patientId
          : null;
      }

      if (formData.hasOwnProperty('mrn')) {
        caseDetail.MRN = (formData.mrn !== null || formData.mrn !== undefined)
          ? formData.mrn
          : null;
      }

      if (online) {
        setLoader(true);
        const {
          CaseScheduleID, CaseDate, CaseTime, CustomerNo, CustomerName, SurgeonName,
          PatientID, ProcedureType, CaseType, Side, Comments, RepNotes, ProductNotes,
          ProductSubmitted, RepPONumber, Submitted, CoverRep, ChangeRep, DGRUpload,
          MRN, Gender, Age, ACMPlannedParts, ACMSelectedParts, Height, Weight, selectedSets,
          ...partialObject
        } = caseDetail;
        const subset = {
          CaseScheduleID,
          CaseDate,
          CaseTime,
          CustomerNo,
          CustomerName,
          SurgeonName,
          PatientID,
          ProcedureType,
          CaseType,
          Side,
          Comments,
          RepNotes,
          ProductNotes,
          ProductSubmitted,
          RepPONumber,
          Submitted,
          CoverRep,
          ChangeRep: name,
          DGRUpload,
          MRN,
          Gender,
          Age,
          ACMPlannedParts,
          ACMSelectedParts,
          Height,
          Weight,
          selectedSets
        };
        const newArrayOfObj = partialObject.case_sets.map(({
          CasePlanId: CasePlanID,
          ...rest
        }) => ({
          CasePlanID,
          ...rest
        }));
        subset.selectedSets = newArrayOfObj;
        // subset.selectedSets = caseDetail.case_sets;
        updateCase(subset).then(async (responseJson) => {
          setLoader(false);
          const { status, message } = responseJson;
          if (status) {
            if (Object.keys(formData).length > 0) {
              // notify({ type: 'success', message });
              if ((caseDetail.case_products.length > 0
                || caseDetail.case_products.length === 0)
                && caseDetail.CaseType === 'HIP' && (vhnPpcValue.VHN_PPC === '1' || vhnPpcValue.VHN_Other === '1')) {
                if (hospitalUseCustCaseIDStatus) {
                  this._onOpenCustomerCaseModal(caseDetail.id);
                } else {
                  this._onAddVhnPpc();
                }
              } else if ((caseDetail.case_products.length > 0
                || caseDetail.case_products.length === 0)
                && caseDetail.CaseType === 'KNEE' && (vhnPpcValue.VRAS_PPC === '1' || vhnPpcValue.VRAS_Other === '1')) {
                if (hospitalUseCustCaseIDStatus) {
                  this._onOpenCustomerCaseModal(caseDetail.id);
                } else {
                  this._onAddVrasPpc();
                }
              } else if (caseDetail.case_products.length > 0) {
                if (hospitalUseCustCaseIDStatus) {
                  this._onOpenCustomerCaseModal(caseDetail.id);
                } else {
                  this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/list`);
                }
              } else {
                if (hospitalUseCustCaseIDStatus) {
                  this._onOpenCustomerCaseModal(caseDetail.id);
                } else {
                  this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
                }
              }
            }

            // Update into local db
            updateCaseByPrimaryId(caseDetail.id, caseDetail);
            // setLoader(false);
            this.setState({ caseDetail });
          } else {
            notify({ type: 'error', message });
          }
        });
      } else {
        caseDetail.Sync = 1;
        this._onGoBack();
        if ((caseDetail.case_products.length > 0
          || caseDetail.case_products.length === 0)
          && caseDetail.CaseType === 'HIP' && (vhnPpcValue.VHN_PPC === '1' || vhnPpcValue.VHN_Other === '1')) {
          if (hospitalUseCustCaseIDStatus) {
            this._onOpenCustomerCaseModal(caseDetail.id);
          } else {
            this._onAddVhnPpc(mrnOrPatientCaseId);
          }
        } else if ((caseDetail.case_products.length > 0
          || caseDetail.case_products.length === 0)
          && caseDetail.CaseType === 'KNEE' && (vhnPpcValue.VRAS_PPC === '1' || vhnPpcValue.VRAS_Other === '1')) {
          if (hospitalUseCustCaseIDStatus) {
            this._onOpenCustomerCaseModal(caseDetail.id);
          } else {
            this._onAddVrasPpc(mrnOrPatientCaseId);
          }
        } else if (caseDetail.case_products.length > 0) {
          if (hospitalUseCustCaseIDStatus) {
            this._onOpenCustomerCaseModal(caseDetail.id);
          } else {
            this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/list`);
          }
        } else {
          if (hospitalUseCustCaseIDStatus) {
            this._onOpenCustomerCaseModal(caseDetail.id);
          } else {
            this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
          }
        }

        // Update into local db
        updateCaseByPrimaryId(caseDetail.id, caseDetail);
        setLoader(false);
        this.setState({ caseDetail });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCustomerCaseIDAdd = async (formData) => {
    try {
      const {
        notify, online, setLoader, tableName, user: { name }
      } = this.props;
      const { mrnOrPatientCaseId } = this.state;
      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      let vhnPpcValue = {};

      if (caseDetail.CustomerName !== null) {
        vhnPpcValue = await getVhnPpcValue(caseDetail.CustomerName);
      }

      if (!Object.keys(formData).length > 0) {
        this._onNextCustomerCaseIDStatus();
        return;
      }

      if (formData.hasOwnProperty('CustCaseID')) {
        caseDetail.CustCaseID = (formData.CustCaseID !== null || formData.CustCaseID !== undefined)
          ? formData.CustCaseID
          : null;
      }

      if (online) {
        setLoader(true);
        const {
          CaseScheduleID, CaseDate, CaseTime, CustomerNo, CustomerName, SurgeonName,
          PatientID, ProcedureType, CaseType, Side, Comments, RepNotes, ProductNotes,
          ProductSubmitted, RepPONumber, Submitted, CoverRep, ChangeRep, DGRUpload,
          MRN, Gender, Age, ACMPlannedParts, ACMSelectedParts, Height, Weight, selectedSets,
          CustCaseID, ...partialObject
        } = caseDetail;
        const subset = {
          CaseScheduleID,
          CaseDate,
          CaseTime,
          CustomerNo,
          CustomerName,
          SurgeonName,
          PatientID,
          ProcedureType,
          CaseType,
          Side,
          Comments,
          RepNotes,
          ProductNotes,
          ProductSubmitted,
          RepPONumber,
          Submitted,
          CoverRep,
          ChangeRep: name,
          DGRUpload,
          MRN,
          Gender,
          Age,
          ACMPlannedParts,
          ACMSelectedParts,
          Height,
          Weight,
          selectedSets,
          CustCaseID,
        };

        const newArrayOfObj = partialObject.case_sets.map(({
          CasePlanId: CasePlanID,
          ...rest
        }) => ({
          CasePlanID,
          ...rest
        }));

        subset.selectedSets = newArrayOfObj;
        updateCase(subset).then(async (responseJson) => {
          setLoader(false);
          const { status, message } = responseJson;
          if (status) {
            if (Object.keys(formData).length > 0) {
              if ((caseDetail.case_products.length > 0
                || caseDetail.case_products.length === 0)
                && caseDetail.CaseType === 'HIP' && (vhnPpcValue.VHN_PPC === '1' || vhnPpcValue.VHN_Other === '1')) {
                this._onAddVhnPpc();
              } else if ((caseDetail.case_products.length > 0
                || caseDetail.case_products.length === 0)
                && caseDetail.CaseType === 'KNEE' && (vhnPpcValue.VRAS_PPC === '1' || vhnPpcValue.VRAS_Other === '1')) {
                this._onAddVrasPpc();
              } else if (caseDetail.case_products.length > 0) {
                this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/list`);
              } else {
                this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
              }
            }

            // Update into local db
            updateCaseByPrimaryId(caseDetail.id, caseDetail);
            // setLoader(false);
            this.setState({ caseDetail });
          } else {
            notify({ type: 'error', message });
          }
        });
      } else {
        caseDetail.Sync = 1;
        this._onGoBack();
        if ((caseDetail.case_products.length > 0
          || caseDetail.case_products.length === 0)
          && caseDetail.CaseType === 'HIP' && (vhnPpcValue.VHN_PPC === '1' || vhnPpcValue.VHN_Other === '1')) {
          this._onAddVhnPpc(mrnOrPatientCaseId);
        } else if ((caseDetail.case_products.length > 0
          || caseDetail.case_products.length === 0)
          && caseDetail.CaseType === 'KNEE' && (vhnPpcValue.VRAS_PPC === '1' || vhnPpcValue.VRAS_Other === '1')) {
          this._onAddVrasPpc(mrnOrPatientCaseId);
        } else if (caseDetail.case_products.length > 0) {
          this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/list`);
        } else {
          this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
        }

        // Update into local db
        updateCaseByPrimaryId(caseDetail.id, caseDetail);
        setLoader(false);
        this.setState({ caseDetail });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCustomerCaseIDBack = async () => {
    try {
      const {
        tableName
      } = this.props;
      const { mrnOrPatientCaseId } = this.state;

      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      let vhnPpcValue = {};

      if (caseDetail.CustomerName !== null) {
        vhnPpcValue = await getVhnPpcValue(caseDetail.CustomerName);
      }

      if ((caseDetail.case_products.length > 0
        || caseDetail.case_products.length === 0)
        && caseDetail.CaseType === 'HIP' && (vhnPpcValue.VHN_PPC === '1' || vhnPpcValue.VHN_Other === '1')) {
        this._onAddVhnPpc(mrnOrPatientCaseId);
      } else if ((caseDetail.case_products.length > 0
        || caseDetail.case_products.length === 0)
        && caseDetail.CaseType === 'KNEE' && (vhnPpcValue.VRAS_PPC === '1' || vhnPpcValue.VRAS_Other === '1')) {
        this._onAddVrasPpc(mrnOrPatientCaseId);
      } else if (caseDetail.case_products.length > 0) {
        this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/list`);
      } else {
        // alert(`/manage-case/${mrnOrPatientCaseId}/products/add`);
        this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmitProductCaseYes = async () => {
    try {
      const {
        notify, setLoader
      } = this.props;
      const { caseDetail } = this.state;
      let responseJson = {};
      caseDetail.Submitted = '1';
      caseDetail.ProductSubmitted = '1';
      await this._getFilterCases();
      const newArrayOfObj = caseDetail.case_sets.map(({
        CasePlanId: CasePlanID,
        ...rest
      }) => ({
        CasePlanID,
        ...rest
      }));
      caseDetail.selectedSets = newArrayOfObj;
      await updateCase(caseDetail);
      setLoader(false);
      responseJson = await listSingleCase(caseDetail.CaseScheduleID);
      const { message, status } = responseJson;
      if (status) {
        const caseDetails = responseJson.data[0];
        caseDetails.id = parseInt(caseDetail.id, 10);
        caseDetails.CaseDate = caseDetail.CaseDate;
        caseDetails.CaseTime = caseDetail.CaseTime;
        // Update the response when update API change
        updateCaseByCaseId(caseDetails.RepCaseNo, caseDetails);
        await this._getFilterCases();
        // updateCaseByPrimaryId(caseDetail.id, caseDetail);
        this.zeroProductSubmitModal.hide();
      } else {
        notify({ type: 'error', message });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSmallLargeCard = () => {
    try {
      const { hideAndShowCard } = this.state;
      const { setCalendarFilter } = this.props;
      this.setState({ hideAndShowCard: !hideAndShowCard }, () => {
        setCalendarFilter({ hideAndShowCard: !hideAndShowCard });
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _goBack = () => {
    try {
      const {
        goBack,
        setCalendarFilter,
        setCaseFilter,
        setSavedScrollPosition
      } = this.props;

      setCalendarFilter({});
      if (goBack[goBack.length - 1] === '/manage-cases') {
        setCaseFilter({});
      }
      setSavedScrollPosition(0);
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getScreenWidth = () => {
    this.setState({ screenWidth: window.screen.width });
  }

  _onGroupByHospital = async () => {
    try {
      const { isGroup } = this.state;
      this.setState({
        isGroup: !isGroup
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSort = async () => {
    try {
      const { orderByFlag, orderByFlagCard } = this.state;
      this.setState({
        orderByFlag: orderByFlag === 'asc' ? 'desc' : 'asc',
        orderByFlagCard: !orderByFlagCard
      }, () => this._getFilterCasesSort());
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getFilterCasesSort = async () => {
    try {
      const { filterCases } = this.state;
      const searchData = {};

      searchData.Date_start = filterCases.mix !== undefined
        ? filterCases.mix[0] !== undefined ? moment(filterCases.mix[0].split('-')[0], 'DD MMM YYYY').format('YYYY/MM/DD') : '' : '';
      searchData.Date_end = filterCases.mix !== undefined
        ? filterCases.mix[0] !== undefined ? moment(filterCases.mix[0].split('-')[1], 'DD MMM YYYY').format('YYYY/MM/DD') : '' : '';
      searchData.CoverRep = filterCases.selectedRefs !== undefined
        ? JSON.stringify(filterCases.selectedRefs)
        : [];
      searchData.Hospital = filterCases.selectHospitals !== undefined
        ? JSON.stringify(filterCases.selectHospitals)
        : [];
      searchData.SurgeonName = filterCases.selectSurgeon !== undefined
        ? JSON.stringify(filterCases.selectSurgeon)
        : [];
      searchData.AltCaseType = filterCases.selectedTypes !== undefined
        ? JSON.stringify(filterCases.selectedTypes)
        : [];
      searchData.ProcedureType = filterCases.ProcedureType !== undefined
        ? JSON.stringify(filterCases.ProcedureType)
        : [];
      searchData.Side = filterCases.Side !== undefined
        ? JSON.stringify(filterCases.Side)
        : [];
      searchData.PatientID = filterCases.PatientID !== undefined
        ? JSON.stringify(filterCases.PatientID.map((element) => element.trim().toUpperCase()))
        : [];
      searchData.RepNotes = filterCases.RepNotes !== undefined
        ? JSON.stringify(filterCases.RepNotes.map((element) => element.trim()))
        : [];
      searchData.Comments = filterCases.Comments !== undefined
        ? JSON.stringify(filterCases.Comments.map((element) => element.trim()))
        : [];
      searchData.SurgeonNotes = filterCases.SurgeonNotes !== undefined
        ? JSON.stringify(filterCases.SurgeonNotes.map((element) => element.trim()))
        : [];
      searchData.PONumber = filterCases.PONumber !== undefined
        ? filterCases.PONumber[0] : '';
      searchData.Keyword = filterCases.keywordSearch !== undefined
        ? JSON.stringify(filterCases.keywordSearch.map((element) => element.trim())) : [];
      searchData.VelysUsed = filterCases.Velys !== undefined
        ? filterCases.Velys[0] : '';
      searchData.CaseNo = filterCases.CaseNo !== undefined
        ? filterCases.CaseNo[0] : '';
      const arraySearchData = {};
      if (filterCases.ProductNo !== undefined) {
        arraySearchData.ProductNo = filterCases.ProductNo;
      }
      this.getFilterCases(filterCases);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _setShipments = async () => {
    try {
      const shipmentsRes = await getShipments({});
      this.setState({ shipments: shipmentsRes.data });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  sortCaseGroupData = (data) => {
    const sortedCaseData = _.sortBy(data,
      [function (item) { return item.customer; }]);
    const filteredNullCaseData = sortedCaseData.filter((item) => item.customer === 'null');
    const filteredCaseData = sortedCaseData.filter((item) => item.customer !== 'null');
    for (const caseData of filteredNullCaseData) {
      filteredCaseData.unshift(caseData);
    }

    return filteredCaseData;
  }

  _onShipmentsTruck = (cases) => {
    if (cases.shipFromLoc === 'ALL') {
      this._onRedirect(`/inventory/shipments?shipFromLoc=DEPUY&shipTo=${cases.customer}`);
    } else if (cases.shipFromLoc === 'DEPUY') {
      this._onRedirect(`/inventory/shipments?shipFromLoc=DEPUY&shipTo=${cases.customer}`);
    } else if (cases.shipFromLoc === 'OFFICE') {
      this._onRedirect(`/inventory/shipments?shipFromLoc=OFFICE&shipTo=${cases.customer}`);
    }
  }

  _onSubmitACMPushCase = async () => {
    try {
      const {
        notify, online, setLoader, tableName
      } = this.props;
      const { caseDetail } = this.state;

      if (online) {
        let responseJson = {};
        setLoader(true);
        responseJson = await listSingleCase(caseDetail.CaseScheduleID);
        const { message, status } = responseJson;
        if (status) {
          const caseDetails = responseJson.data[0];
          caseDetails.id = parseInt(caseDetail.id, 10);
          caseDetails.CaseDate = caseDetail.CaseDate;
          caseDetails.CaseTime = caseDetail.CaseTime;
          // Update the response when update API change
          updateTableWiseCaseByCaseId(caseDetails.RepCaseNo, caseDetails, tableName);
          await this._getFilterCases();
        } else {
          notify({ type: 'error', message });
        }
      } else {
        notify({
          type: 'error',
          message: 'You must have an internet connection. Please check your connection and try again.',
          time: 5
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onACMPushCase = async (id) => {
    try {
      const {
        notify, online, tableName
      } = this.props;

      if (online) {
        const caseDetail = await getTableCaseByCaseId(id, tableName);
        this.setState({ caseDetail });

        if (caseDetail.ACM === '0') {
          this.setState({
            acmPushCaseStatusCount: 1
          });
          this._onACMPushCaseStatus();
        } else {
          this._onACMPushCaseConfirm();
        }
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
      }
    } catch (error) {
      Bugsnag.notify(error);
    }
  }

  _onPushCaseYes = async () => {
    try {
      const {
        online,
        notify,
      } = this.props;
      const {
        caseDetail: {
          Age,
          Gender,
          Height,
          HeightUnits,
          PatientID,
          Weight,
          WeightUnits,
          case_xrays,
          MRN,
          Side,
        },
      } = this.state;

      if (online) {
        let xrayCountFlag = 0;
        const xrayStatusFlag = typeof case_xrays !== 'undefined' ? case_xrays.length : 0;
        if (xrayStatusFlag > 0) {
          case_xrays.forEach((element) => {
            if (
              element.Filename.includes('.dcm')
              || element.Filename.includes('.jpeg')
              || element.Filename.includes('.jpg')
            ) {
              xrayCountFlag++;
            }
          });
        }

        if (Number(xrayCountFlag) > 0) {
          const MessageStatusFlag = [];
          if ((PatientID === '' || PatientID === null) && (MRN === '' || MRN === null)) {
            MessageStatusFlag.push('Patient or MRN');
          }

          if (Side === '' || Side === null) {
            MessageStatusFlag.push(MessageStatusFlag.length > 0 ? '& Side' : 'Side');
          }

          if (MessageStatusFlag.length > 0) {
            this.setState({
              acmMessageStatusFlag: MessageStatusFlag,
              acmPushCaseStatusCount: 5
            });
            this._onACMPushCaseStatus();
          } else {
            this._updatePushToACM();
          }
        } else {
          const fieldsToCheck = [
            { field: Age, name: 'Age' },
            { field: Gender, name: 'Gender' },
            { field: Height, name: 'Height' },
            { field: HeightUnits, name: 'Height Units' },
            { field: Side, name: 'Side' },
            { field: Weight, name: 'Weight' },
            { field: WeightUnits, name: 'Weight Units' },
          ];

          const MessageStatusFlag = fieldsToCheck.filter(
            ({ field }) => typeof field === 'undefined' || field === null || field === '' || field === '.00'
          )
            .map(({ name }) => name);

          if ((PatientID === '' || PatientID === null) && (MRN === '' || MRN === null)) {
            MessageStatusFlag.push('Patient or MRN');
          }

          if (MessageStatusFlag.length > 0) {
            this.setState({
              acmPushCaseStatusCount: 2,
              acmMessageStatusFlag: MessageStatusFlag.sort()
            });
            this._onACMPushCaseStatus();
          } else {
            this._updatePushToACM();
          }
        }
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _updatePushToACM = async () => {
    try {
      const {
        online,
        notify,
        setLoader,
        user: {
          territories,
          territoryId
        }
      } = this.props;
      const {
        caseDetail: {
          CaseScheduleID
        },
      } = this.state;

      if (online) {
        setLoader(true);
        const pushData = {
          caller: 'OPT'
        };

        territories.map((item) => {
          if (item.id === territoryId) {
            pushData.TerritoryCode = item.abb;
          }
        });

        const acmResponseJson = await updatePushToACM(CaseScheduleID, pushData);
        const { message, status, result } = acmResponseJson;
        setLoader(false);
        if (typeof result !== 'undefined' && result === 'failure') {
        } else {
          if (status) {
            this.setState({
              acmPushCaseStatusCount: 4,
              acmMessageStatusMessage: message
            });
          } else {
            this.setState({
              acmPushCaseStatusCount: 3,
              acmMessageStatusMessage: message
            });
          }

          this._onACMPushCaseStatus();
        }
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onPushCaseStatus = async () => {
    try {
      const {
        online,
        notify,
      } = this.props;
      const { acmPushCaseStatusCount } = this.state;
      if (online) {
        this.setState({
          acmPushCaseStatusCount: 0,
          acmMessageStatusFlag: [],
          acmMessageStatusMessage: ''
        });

        if (acmPushCaseStatusCount === 4) {
          this._onSubmitACMPushCase();
        }
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onPushCaseNo = () => {
    try {
      const {
        online, notify
      } = this.props;
      if (online) {
        this.setState({
          acmPushCaseStatusCount: 0,
          acmMessageStatusFlag: [],
          acmMessageStatusMessage: ''
        });
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onACMPushCaseStatus = () => {
    try {
      const acmPushCaseStatus = new window.bootstrap.Modal(window.$('#acmPushCaseStatusModal'));
      acmPushCaseStatus.show();
    } catch (error) {
      Bugsnag.notify(error);
    }
  }

  _onACMPushCaseConfirm = () => {
    try {
      const acmPushCaseConfirm = new window.bootstrap.Modal(window.$('#acmPushCaseConfirmModal'));
      acmPushCaseConfirm.show();
    } catch (error) {
      Bugsnag.notify(error);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const {
        caseFilter,
        calendarFilter,
        online,
        user: {
          isBigCards
        },
      } = this.props;
      let { filterCases } = this.state;
      await this._getScreenWidth();

      const user = await getUser();
      if (user.isGroupByHospital) {
        this.setState({
          isGroup: user.isGroupByHospital
        });
      }

      if (online) {
        this._setShipments();
      }

      const selectedStartDate = Array.isArray(caseFilter.selectedStartDate)
        ? caseFilter.selectedStartDate
        : [moment(caseFilter.selectedStartDate).format('DD MMM YYYY')];

      const selectedEndDate = Array.isArray(caseFilter.selectedEndDate)
        ? caseFilter.selectedEndDate
        : [moment(caseFilter.selectedEndDate).format('DD MMM YYYY')];

      if ((caseFilter.selectedEndDate !== '' && caseFilter.selectedEndDate !== undefined)
        || (caseFilter.selectedStartDate !== '' && caseFilter.selectedStartDate !== undefined)) {
        const mix = [`${selectedStartDate[0]} - ${selectedEndDate[0]}`];
        filterCases = { ...filterCases, mix };
        caseFilter.mix = `${selectedStartDate[0]} - ${selectedEndDate[0]}`;
      } else if (caseFilter.mix !== '' && caseFilter.mix !== undefined) {
        const selectedDate = Array.isArray(caseFilter.mix)
          ? caseFilter.mix
          : [caseFilter.mix];
        filterCases = { ...filterCases, mix: selectedDate };
      }

      delete caseFilter.selectedStartDate;
      delete caseFilter.selectedEndDate;
      this.setState({
        filterCases: { ...caseFilter, ...filterCases },
        hideAndShowCard: isBigCards === true ? false
          : isBigCards === false ? true
            : calendarFilter.hideAndShowCard
      }, () => this._getFilterCases());
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      hideAndShowCard,
      filterCases,
      localFilterCases,
      caseDetail,
      acmCases,
      screenWidth,
      isGroup,
      hospitalGroupCasesListData,
      orderByFlagCard,
      acmPushCaseStatusCount,
      acmMessageStatusFlag,
      acmMessageStatusMessage,
    } = this.state;
    const {
      user: {
        scanner, territories, selectedTeam, territoryId
      }
    } = this.props;
    let indexKey = 1;
    return (
      <section className="filter-section resizer-class">
        <Header
          actionButton={{ title: 'Exit', onClick: this._onClearFilter }}
          title="Search Cases"
          goBack={this._goBack}
        />
        <div className="container resizer-class p-0">
          <div className="top-block sticky-filter-cases pt-10 pb-10">
            <div className="row pl-15 pr-15">
              <div className="col">
                <h5 className="mt-10">Cases: {localFilterCases.length}</h5>
              </div>

              <div className="col text-end p-0">
                <button
                  className={`btn btn-link link ${screenWidth < 800 ? 'mobile-clock-icon' : ''}`}
                  style={{ paddingRight: '5px' }}
                  onClick={this._onGroupByHospital}
                >
                  {
                    (!isGroup)
                      ? <img width="24px" src={HospitalBoxIcon} alt="arrow" />
                      : <img width="24px" src={ClockTimeIcon} alt="arrow" />
                  }
                </button>

                <button
                  className={`btn btn-link link ${screenWidth < 800 ? 'mobile-clock-icon' : ''}`}
                  style={{ paddingRight: '5px' }}
                  onClick={this._onSort}
                >
                  {orderByFlagCard ? <img width="20px" src={AscIcon} alt="arrow" /> : <img width="20px" src={DescIcon} alt="arrow" />}
                </button>

                <button
                  className={`btn btn-link link ${screenWidth < 800 ? 'mobile-clock-icon' : ''}`}
                  style={{ paddingRight: '3px' }}
                  onClick={this._onSmallLargeCard}
                >
                  {hideAndShowCard ? <img width="28px" src={ArrowExpand} alt="arrow" /> : <img width="24px" src={ArrowCollapse} alt="arrow" />}
                </button>
              </div>

            </div>

            <div className="calender-section" />

            <div className="row gx-3 mt-10 pl-15 pr-15">
              {
                (
                  filterCases && Object.keys(filterCases).map((key) => (
                    filterCases[key].map((item, index) => (
                      <div key={index} className="col-6">
                        <div className="selection selection-sm">
                          {key === 'Velys' ? (
                            <p className="text-ellipsis-filter-ops">VELYS: {item[0] === 'N' ? 'No' : 'Yes'}</p>
                          ) : (
                            <p className="text-ellipsis-filter-ops">{item}</p>
                          )}
                          <button className="btn" onClick={() => this._onUnselectValue(key, index)}><i className="fas fa-times" /></button>
                        </div>
                      </div>
                    ))
                  ))
                )
              }
            </div>
          </div>

          <section className="cards-section">
            <div className="row" style={{ paddingBottom: '10px' }}>
              {
                (hospitalGroupCasesListData.length > 0)
                && hospitalGroupCasesListData.map((caseValue, caseKey) => (
                  <div key={caseKey + (indexKey++)}>
                    <div style={{ top: 156, position: 'sticky', zIndex: 10 }}>
                      <h4
                        className="bg-label"
                        style={{
                          backgroundColor: '#0E120F',
                          fontSize: 15,
                          width: '100%',
                          padding: '8px 15px',
                          marginBottom: 0,
                          zIndex: 999,
                        }}
                      >{moment(caseValue.date).format('dddd, MMM DD, YYYY')}
                      </h4>
                    </div>

                    {
                      isGroup
                        ? (caseValue.data.length > 0)
                        && caseValue.data.map((cases, key) => (
                          <div key={(key * 10) + (indexKey++)}>
                            <div
                              className="row bg-theme"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapse${caseKey}-${(key * 10) + (indexKey++)}`}
                              style={{
                                backgroundColor: '#212121',
                                margin: 0,
                                padding: '5px',
                                top: 190,
                                position: 'sticky',
                                zIndex: 99,
                                paddingRight: 0
                              }}
                              aria-expanded="false"
                            >
                              <div className="d-flex align-items-center" style={{ height: '40px' }}>
                                <div>{cases.customer === 'null' ? '-' : cases.customer}</div>
                                {
                                  cases.hasShipments ? (
                                    <>
                                      <div className="case-truck ml-auto">
                                        <span className="cartNo" />
                                        <Link
                                          className="cursor-pointer"
                                          onClick={() => this._onShipmentsTruck(cases)}
                                        >
                                          <img width="25px" src={TruckOutlineIcon} alt="shipments" />
                                        </Link>
                                      </div>
                                      <div className="case-cart">
                                        <span className="cartNo">{cases.qty}</span>
                                        <Link
                                          className="cursor-pointer"
                                          onClick={cases.customer === 'null'
                                            ? () => { }
                                            : () => this._onRedirect(`/manage-case/aggregate-plan/${cases.id}`)}
                                        >
                                          <img width="25px" src={CartOutlineIcon} alt="cart" />
                                        </Link>
                                      </div>
                                    </>
                                  ) : (
                                    <div className="case-cart ml-auto">
                                      <span className="cartNo">{cases.qty}</span>
                                      <Link
                                        className="cursor-pointer"
                                        onClick={cases.customer === 'null'
                                          ? () => { }
                                          : () => this._onRedirect(`/manage-case/aggregate-plan/${cases.id}`)}
                                      >
                                        <img width="25px" src={CartOutlineIcon} alt="cart" />
                                      </Link>
                                    </div>
                                  )
                                }
                              </div>
                            </div>

                            <div className="collapse show" id={`#collapse${caseKey}-${(key * 10) + (indexKey++)}`}>
                              <div style={{
                                width: '100%',
                                marginBottom: 10
                              }}
                              >
                                <div className="row pl-15 pr-15">
                                  {
                                    cases.data.map((data) => (
                                      <CaseRow
                                        key={(key * 100) + (indexKey++)}
                                        keyValue={(key * 100) + (indexKey++)}
                                        data={data}
                                        smallLargeCard={hideAndShowCard}
                                        onRedirect={this._onRedirect}
                                        onFilter={this._onFilter}
                                        onCancel={this._onCancel}
                                        onGetACMCase={this._onGetACMCase}
                                        onSubmitCase={this._onSubmitCase}
                                        onMrnPatientIdAdd={this._onOpenMrnPatientIdModal}
                                        table="Cases"
                                        filterCase="filterCase"
                                        onCaseSubmitted={this._onCaseSubmitted}
                                        scanner={scanner}
                                        territories={territories}
                                        territoryId={territoryId}
                                        selectedTeam={selectedTeam}
                                        screenWidth={screenWidth}
                                        addVhnPpc={this._onAddVhnPpc}
                                        addVrasPpc={this._onAddVrasPpc}
                                        type="caseCard"
                                        onACMPushCase={this._onACMPushCase}
                                        onCustomerCaseAdd={this._onOpenCustomerCaseModal}
                                      />
                                    ))
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        )) : (caseValue.dataNonGroup.length > 0)
                        && caseValue.dataNonGroup.map((cases, key) => (
                          <div key={(key * 1000) + (indexKey++)}>
                            <div style={{
                              width: '100%',
                              marginBottom: 10
                            }}
                            >
                              <div className="row pl-15 pr-15">
                                <CaseRow
                                  key={(key * 1000) + (indexKey++)}
                                  keyValue={(key * 1000) + (indexKey++)}
                                  data={cases}
                                  smallLargeCard={hideAndShowCard}
                                  onRedirect={this._onRedirect}
                                  onFilter={this._onFilter}
                                  onCancel={this._onCancel}
                                  onGetACMCase={this._onGetACMCase}
                                  onSubmitCase={this._onSubmitCase}
                                  onMrnPatientIdAdd={this._onOpenMrnPatientIdModal}
                                  table="Cases"
                                  filterCase="filterCase"
                                  onCaseSubmitted={this._onCaseSubmitted}
                                  scanner={scanner}
                                  territories={territories}
                                  territoryId={territoryId}
                                  selectedTeam={selectedTeam}
                                  screenWidth={screenWidth}
                                  addVhnPpc={this._onAddVhnPpc}
                                  addVrasPpc={this._onAddVrasPpc}
                                  isGroup={isGroup}
                                  type="caseCard"
                                  onACMPushCase={this._onACMPushCase}
                                  onCustomerCaseAdd={this._onOpenCustomerCaseModal}
                                />
                              </div>
                            </div>
                          </div>
                        ))
                    }
                  </div>
                ))
              }
            </div>

            <div className="row" style={{ paddingBottom: '10px' }}>
              <ZeroProductSubmitModal
                onSubmitProductCaseYes={this._onSubmitProductCaseYes}
                onSubmitProductCaseNo={this._onSubmitProductCaseNo}
                caseDetail={caseDetail}
              />
              <MrnOrPatientIdModal onSubmit={this._onMrnPatientIdAdd} />
              <RequiredMrnOrPatientId onClickOk={this._onAddPatientIdOrMrn} />
              <AlreadySubmittedCase />
              <CancelCaseModal
                onCancelCase={this._onCaseCancel}
                onCaseRowAcmCase={acmCases}
                onCancelCaseBack={this._onCancelCaseBack}
              />
              <CaseChangesNoLonger
                id={caseDetail.id}
              />
              <VhnPpcModal
                onClickNo={this._onClickVhnPpcNo}
                onClickYes={this._onClickVhnPpcYes}
              />
              <VrasPpcModal
                onClickNo={this._onClickVrasPpcNo}
                onClickYes={this._onClickVrasPpcYes}
              />
              <AcmPushCaseConfirmModal
                onPushCaseYes={this._onPushCaseYes}
                onPushCaseNo={this._onPushCaseNo}
              />
              <AcmPushCaseStatusModal
                messageStatus={acmPushCaseStatusCount}
                onPushCaseStatus={this._onPushCaseStatus}
                acmMessageStatusFlag={acmMessageStatusFlag}
                acmMessageStatusMessage={acmMessageStatusMessage}
              />

              <CustCaseIDModal
                onSubmit={this._onCustomerCaseIDAdd}
                onBack={this._onCustomerCaseIDBack}
              />
              <RequiredCustCaseID onClickOk={this._onCustomerCaseIDStatus} />
            </div>
          </section>
        </div>
        <ExceedsSearchResult />
      </section>
    );
  }
}

export default withVhnPpcOtherCharge(
  withUser(
    withCalendarFilter(
      withTableName(
        withLoader(
          withOnline(
            withNotify(
              withCaseFilter(
                withGoBack(
                  withTeam(
                    withSavedScrollPosition(
                      FilterCases
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);
